import { CatalogOptionViewModel } from '@common/model/catalog/options/view';
import { IAdvantage } from '../../../../../../packages/entities/advantage';

export const optionToAdvantage = (option: CatalogOptionViewModel): IAdvantage => {
  return { icon: option.icon?.value, name: option.id, title: option.translation.title };
};
